(function () {
  var bar = document.createElement('div');
  bar.className = 'riwayat-loading-bar';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  function shouldIntercept(link) {
    if (!link || !link.href) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download')) return false;
    if (link.href.indexOf('mailto:') === 0 || link.href.indexOf('tel:') === 0) return false;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return false;
    }
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) {
      return false;
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (!shouldIntercept(link)) return;
    bar.classList.add('is-active');
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.target && form.target !== '_self') return;
    bar.classList.add('is-active');
  });

  window.addEventListener('pageshow', function () {
    bar.classList.remove('is-active');
  });
})();
